import React from 'react';

const FeatureIcons = (props) => {
  const icon = (props) => {
    let icon;
    switch (props.feature) {
      case 'ideas-dashboard':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/home-trend-up">
              <g id="home-trend-up">
                <path
                  id="Vector"
                  d="M7.51666 2.36667L3.02499 5.86667C2.27499 6.45 1.66666 7.69167 1.66666 8.63334V14.8083C1.66666 16.7417 3.24166 18.325 5.17499 18.325H14.825C16.7583 18.325 18.3333 16.7417 18.3333 14.8167V8.75C18.3333 7.74167 17.6583 6.45 16.8333 5.875L11.6833 2.26667C10.5167 1.45 8.64166 1.49167 7.51666 2.36667Z"
                  fill="white"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g id="Vector_2">
                  <path
                    d="M13.75 9.58333L10.25 13.0833L8.91667 11.0833L6.25 13.75"
                    fill="white"
                  />
                  <path
                    d="M13.75 9.58333L10.25 13.0833L8.91667 11.0833L6.25 13.75"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <g id="Vector_3">
                  <path d="M12.0833 9.58333H13.75V11.25" fill="white" />
                  <path
                    d="M12.0833 9.58333H13.75V11.25"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </g>
            </g>
          </svg>
        );
        break;

      case 'timeline':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/row-vertical">
              <g id="row-vertical">
                <g id="Group 1">
                  <path
                    id="Vector"
                    d="M14.9997 18H4.99966"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    id="Vector_2"
                    d="M15 2H5"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    id="Vector_3"
                    d="M16.5833 5.5H3.41666C2.16666 5.5 1.66666 6.17765 1.66666 7.86118V12.1388C1.66666 13.8224 2.16666 14.5 3.41666 14.5H16.5833C17.8333 14.5 18.3333 13.8224 18.3333 12.1388V7.86118C18.3333 6.17765 17.8333 5.5 16.5833 5.5Z"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </g>
            </g>
          </svg>
        );
        break;

      case 'watchlist':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/archive-tick">
              <g id="archive-tick">
                <path
                  id="Vector"
                  d="M14.0167 1.66666H5.98333C4.20833 1.66666 2.76666 3.11666 2.76666 4.88332V16.625C2.76666 18.125 3.84166 18.7583 5.15833 18.0333L9.225 15.775C9.65833 15.5333 10.3583 15.5333 10.7833 15.775L14.85 18.0333C16.1667 18.7667 17.2417 18.1333 17.2417 16.625V4.88332C17.2333 3.11666 15.7917 1.66666 14.0167 1.66666Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M7.99167 9.16668L9.24167 10.4167L12.575 7.08334"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        );
        break;

      case 'alerts':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/notification-bing">
              <g id="notification-bing">
                <path
                  id="Vector"
                  d="M10 5.36667V8.14167"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  id="Vector_2"
                  d="M10.0167 1.66666C6.95001 1.66666 4.46667 4.14999 4.46667 7.21666V8.96666C4.46667 9.53332 4.23334 10.3833 3.94167 10.8667L2.88334 12.6333C2.23334 13.725 2.68334 14.9417 3.88334 15.3417C7.86667 16.6667 12.175 16.6667 16.1583 15.3417C17.2833 14.9667 17.7667 13.65 17.1583 12.6333L16.1 10.8667C15.8083 10.3833 15.575 9.52499 15.575 8.96666V7.21666C15.5667 4.16666 13.0667 1.66666 10.0167 1.66666Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  id="Vector_3"
                  d="M12.775 15.6833C12.775 17.2083 11.525 18.4583 10 18.4583C9.24167 18.4583 8.54167 18.1417 8.04167 17.6417C7.54167 17.1417 7.22501 16.4417 7.22501 15.6833"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                />
              </g>
            </g>
          </svg>
        );
        break;

      case 'portfolio':
        icon = props.highlight ? (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/graph">
              <g id="graph">
                <path
                  id="Vector"
                  d="M15.2667 10C17.4333 10 18.3333 9.16667 17.5333 6.43334C16.9917 4.59167 15.4083 3.00834 13.5667 2.46667C10.8333 1.66667 10 2.56667 10 4.73334V7.13334C10 9.16667 10.8333 10 12.5 10H15.2667Z"
                  fill="#FFC008"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M16.6667 12.25C15.8917 16.1083 12.1917 18.9083 7.98333 18.225C4.82499 17.7167 2.28333 15.175 1.76666 12.0167C1.09166 7.82501 3.87499 4.12501 7.71666 3.34167"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        ) : (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/graph">
              <g id="graph">
                <path
                  id="Vector"
                  d="M15.2667 10C17.4333 10 18.3333 9.16667 17.5333 6.43334C16.9917 4.59167 15.4083 3.00834 13.5667 2.46667C10.8333 1.66667 10 2.56667 10 4.73334V7.13334C10 9.16667 10.8333 10 12.5 10H15.2667Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M16.6667 12.25C15.8917 16.1083 12.1917 18.9083 7.98333 18.225C4.82499 17.7167 2.28333 15.175 1.76666 12.0167C1.09166 7.82501 3.87499 4.12501 7.71666 3.34167"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        );
        break;

      case 'stock-screener':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/setting-4">
              <g id="setting-4">
                <path
                  id="Vector"
                  d="M18.3333 5.41666H13.3333"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M4.99999 5.41666H1.66666"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_3"
                  d="M8.33332 8.33333C9.94415 8.33333 11.25 7.0275 11.25 5.41667C11.25 3.80584 9.94415 2.5 8.33332 2.5C6.72249 2.5 5.41666 3.80584 5.41666 5.41667C5.41666 7.0275 6.72249 8.33333 8.33332 8.33333Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_4"
                  d="M18.3333 14.5833H15"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_5"
                  d="M6.66666 14.5833H1.66666"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_6"
                  d="M11.6667 17.5C13.2775 17.5 14.5833 16.1942 14.5833 14.5833C14.5833 12.9725 13.2775 11.6667 11.6667 11.6667C10.0558 11.6667 8.75 12.9725 8.75 14.5833C8.75 16.1942 10.0558 17.5 11.6667 17.5Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        );
        break;

      case 'markets':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/presention-chart">
              <g id="presention-chart">
                <path
                  id="Vector"
                  d="M4.91667 14.1667H15.075C16.6583 14.1667 17.4917 13.3333 17.4917 11.75V1.66666H2.49167V11.75C2.5 13.3333 3.33334 14.1667 4.91667 14.1667Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M1.66666 1.66666H18.3333"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_3"
                  d="M6.66666 18.3334L9.99999 16.6667V14.1667"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_4"
                  d="M13.3333 18.3334L10 16.6667"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_5"
                  d="M6.25 9.16666L8.87499 6.97499C9.08333 6.79999 9.35833 6.84999 9.49999 7.08332L10.5 8.74999C10.6417 8.98332 10.9167 9.02499 11.125 8.85833L13.75 6.66666"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        );
        break;

      case 'macro':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/favorite-chart">
              <g id="favorite-chart">
                <path
                  id="Vector"
                  d="M18.3333 10.8334V7.50002C18.3333 3.33335 16.6667 1.66669 12.5 1.66669H7.49999C3.33332 1.66669 1.66666 3.33335 1.66666 7.50002V12.5C1.66666 16.6667 3.33332 18.3334 7.49999 18.3334H10.8333"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M6.10834 12.075L8.09167 9.49999C8.37501 9.13332 8.90001 9.06666 9.26668 9.34999L10.7917 10.55C11.1584 10.8333 11.6833 10.7667 11.9667 10.4083L13.8917 7.92499"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g id="Group">
                  <path
                    id="Vector_3"
                    d="M16.2333 13.1833L16.4667 13.6583C16.5833 13.8917 16.875 14.1083 17.1333 14.1583L17.45 14.2083C18.4 14.3667 18.625 15.0667 17.9417 15.7583L17.65 16.05C17.4583 16.25 17.35 16.6333 17.4083 16.9L17.45 17.075C17.7083 18.225 17.1 18.6666 16.1 18.0666L15.8833 17.9417C15.625 17.7917 15.2083 17.7917 14.95 17.9417L14.7333 18.0666C13.725 18.675 13.1167 18.225 13.3833 17.075L13.425 16.9C13.4833 16.6333 13.375 16.25 13.1833 16.05L12.8917 15.7583C12.2083 15.0667 12.4333 14.3667 13.3833 14.2083L13.7 14.1583C13.95 14.1167 14.25 13.8917 14.3667 13.6583L14.6 13.1833C15.05 12.275 15.7833 12.275 16.2333 13.1833Z"
                    stroke="#818181"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </g>
            </g>
          </svg>
        );
        break;

      case 'raw-materials':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/colorfilter">
              <g id="colorfilter">
                <path
                  id="Vector"
                  d="M11.6667 13.3334C11.6667 14.8084 11.025 16.1417 9.99999 17.05C9.11666 17.85 7.94999 18.3334 6.66666 18.3334C3.90832 18.3334 1.66666 16.0917 1.66666 13.3334C1.66666 11.0334 3.23332 9.08336 5.34999 8.50836C5.92499 9.95836 7.15832 11.075 8.68332 11.4917C9.09999 11.6084 9.54166 11.6667 9.99999 11.6667C10.4583 11.6667 10.9 11.6084 11.3167 11.4917C11.5417 12.0584 11.6667 12.6834 11.6667 13.3334Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M15 6.66669C15 7.31669 14.875 7.94169 14.65 8.50835C14.075 9.95835 12.8417 11.075 11.3167 11.4917C10.9 11.6084 10.4583 11.6667 10 11.6667C9.54167 11.6667 9.1 11.6084 8.68333 11.4917C7.15833 11.075 5.925 9.95835 5.35 8.50835C5.125 7.94169 5 7.31669 5 6.66669C5 3.90835 7.24167 1.66669 10 1.66669C12.7583 1.66669 15 3.90835 15 6.66669Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_3"
                  d="M18.3333 13.3334C18.3333 16.0917 16.0917 18.3334 13.3333 18.3334C12.05 18.3334 10.8833 17.85 10 17.05C11.025 16.1417 11.6667 14.8084 11.6667 13.3334C11.6667 12.6834 11.5417 12.0584 11.3167 11.4917C12.8417 11.075 14.075 9.95836 14.65 8.50836C16.7667 9.08336 18.3333 11.0334 18.3333 13.3334Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        );
        break;

      case 'company-sector-research':
        icon = (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/search-normal">
              <g id="search-normal">
                <path
                  id="Vector"
                  d="M9.58335 17.5C13.9556 17.5 17.5 13.9556 17.5 9.58335C17.5 5.2111 13.9556 1.66669 9.58335 1.66669C5.2111 1.66669 1.66669 5.2111 1.66669 9.58335C1.66669 13.9556 5.2111 17.5 9.58335 17.5Z"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="Vector_2"
                  d="M18.3334 18.3334L16.6667 16.6667"
                  stroke="#818181"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        );
        break;

      default:
        break;
    }
    return icon;
  };

  return icon(props);
};

export default FeatureIcons;
